export default function R_DataSet() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_DataSet Component</h1>
      <p>This is the R_DataSet tutorial section.</p>
    </div>
  );
}
